import { render, staticRenderFns } from "./EditorControlsMobile.vue?vue&type=template&id=52d75530&scoped=true"
import script from "./EditorControlsMobile.vue?vue&type=script&lang=js"
export * from "./EditorControlsMobile.vue?vue&type=script&lang=js"
import style0 from "./EditorControlsMobile.vue?vue&type=style&index=0&id=52d75530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d75530",
  null
  
)

export default component.exports